// extracted by mini-css-extract-plugin
export default {"footerSection":"components_footerSection__VWxzt","footerSectionInner":"components_footerSectionInner__yqWU6","footerLinks":"components_footerLinks__++d-1"};